import React from 'react'
import { withIcon } from '../../withIcon'

function MovieIcon (props) {
  const {
    size = '24px',
    color = 'currentColor',
  } = props

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none">
      <path fillRule="evenodd" clipRule="evenodd" d="M6 4.625C5.24061 4.625 4.625 5.24061 4.625 6V7.375H7.375V4.625H6ZM6 3.375C4.55025 3.375 3.375 4.55025 3.375 6V18C3.375 19.4497 4.55025 20.625 6 20.625H18C19.4497 20.625 20.625 19.4497 20.625 18V6C20.625 4.55025 19.4497 3.375 18 3.375H6ZM8.625 4.625V11.375H15.375V4.625H8.625ZM16.625 4.625V7.375H19.375V6C19.375 5.24061 18.7594 4.625 18 4.625H16.625ZM19.375 8.625H16.625V11.375H19.375V8.625ZM19.375 12.625H16.625V15.375H19.375V12.625ZM19.375 16.625H16.625V19.375H18C18.7594 19.375 19.375 18.7594 19.375 18V16.625ZM15.375 19.375V12.625H8.625V19.375H15.375ZM7.375 19.375V16.625H4.625V18C4.625 18.7594 5.24061 19.375 6 19.375H7.375ZM4.625 15.375H7.375V12.625H4.625V15.375ZM4.625 11.375H7.375V8.625H4.625V11.375Z" fill={color}/>
    </svg>
  )
}

export default withIcon(MovieIcon)
